import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal', 'kakaoPreview', 'emailPreview', 'preview', 'kakaotalkDesc', 'reservedAtInput'];

  openModal() {
    document.body.classList.add('overflow-hidden');
    this.modalTarget.classList.remove('hidden');
  }

  closeModal() {
    document.body.classList.remove('overflow-hidden');
    this.modalTarget.classList.add('hidden');
  }

  togglePreview() {
    this.previewTarget.classList.toggle('hidden');
  }

  openKakaoPreview() {
    this.kakaoPreviewTarget.classList.remove('hidden');
    this.emailPreviewTarget.classList.add('hidden');
    this.kakaotalkDescTarget.classList.remove('hidden');
  }

  openEmailPreview() {
    this.kakaoPreviewTarget.classList.add('hidden');
    this.emailPreviewTarget.classList.remove('hidden');
    this.kakaotalkDescTarget.classList.add('hidden');
  }
}
